export const MAIN_SIDEBAR_WIDTH = 12;
export const MAIN_TOPBAR_HEIGHT = 12;
